import { axiosInstance as axios } from 'hb-react/shared/utils/axios';

import getRailsType from './getRailsType';
import {
  updateItemsLikes,
  updateCurrentNewItemLikes,
} from './updateFeedItemsState';

const toggleLike = ({
  routes,
  likeId,
  likeableId,
  type,
  setItems,
  setCurrentNewItem,
  flagEvNewsRevamp,
}) => {
  const likeableType = getRailsType(type);

  if (likeId) {
    return axios.delete(routes.like_path(likeableType, likeId)).then(() => {
      if (setItems) {
        updateItemsLikes({
          setItems,
          likeableId,
          type,
          increaseCount: false,
          flagEvNewsRevamp,
        });
      }
      if (setCurrentNewItem) {
        updateCurrentNewItemLikes({
          setCurrentNewItem,
          likeableId,
          type,
          increaseCount: false,
        });
      }

      return null;
    });
  }

  return axios
    .post(routes.likes_path(), {
      like: {
        likeable_id: likeableId,
        likeable_type: getRailsType(type),
      },
    })
    .then(({ data: { like } }) => {
      if (setItems) {
        updateItemsLikes({
          setItems,
          likeableId,
          type,
          like,
          increaseCount: true,
          flagEvNewsRevamp,
        });
      }

      if (setCurrentNewItem) {
        updateCurrentNewItemLikes({
          setCurrentNewItem,
          likeableId,
          type,
          like,
          increaseCount: true,
        });
      }

      return like;
    });
};

export default toggleLike;
